export default {"src":"/_next/static/media/list_is_empty_gt.998caf90.svg","height":154,"width":220};